// 从 省/市/区 中提取市名（如 江苏/南京 -> 南京）
export function getCityName(str) {
  if (!str) return '';
  const parts = str.split(/[\/\-]/).filter(Boolean);
  return parts[1] || parts[0] || '';
}

// 家乡显示：安徽/合肥 -> 安徽合肥人
export function formatHometown(str) {
  if (!str) return '';
  const parts = str.split(/[\/\-]/).filter(Boolean);
  if (parts.length >= 2) return parts[0] + parts[1] + '人';
  if (parts.length === 1) return parts[0] + '人';
  return str.replace(/\//g, '');
}

// 所在地显示：安徽/合肥 -> 现居合肥
export function formatCity(str) {
  if (!str) return '';
  const parts = str.split(/[\/\-]/).filter(Boolean);
  const cityPart = parts[1] || parts[0];
  return cityPart ? `现居${cityPart}` : '';
}
